"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldSwitchCoreInputs = exports.SwitchLabelPosition = void 0;
var SwitchLabelPosition;
(function (SwitchLabelPosition) {
    SwitchLabelPosition["LEFT"] = "left";
    SwitchLabelPosition["RIGHT"] = "right";
})(SwitchLabelPosition || (exports.SwitchLabelPosition = SwitchLabelPosition = {}));
class EmeraldSwitchCoreInputs {
    constructor() {
        this.id = `Switch${Math.random().toString()}`;
        this.labelPosition = SwitchLabelPosition.RIGHT;
        this.disabled = false;
        this.selected = false;
        this.hasOnOffIcon = false;
        this.showThumbIcon = false;
        this.iconWhenOn = 'checkmark';
        this.iconWhenOff = 'remove';
    }
}
exports.EmeraldSwitchCoreInputs = EmeraldSwitchCoreInputs;
//# sourceMappingURL=switch.inputs.js.map